// Miles North — Theme JS
(function () {
  // Year
  var y = document.getElementById('mn-year');
  if (y) y.textContent = new Date().getFullYear();

  // Nav scroll
  var nav = document.getElementById('mn-nav');
  function updateNav() { if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();

  // Mobile menu
  var ham = document.getElementById('mn-hamburger');
  var mob = document.getElementById('mn-mobile-menu');
  function openMenu() { ham.classList.add('is-open'); mob.classList.add('is-open'); ham.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { ham.classList.remove('is-open'); mob.classList.remove('is-open'); ham.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
  if (ham) ham.addEventListener('click', function () { mob.classList.contains('is-open') ? closeMenu() : openMenu(); });
  if (mob) mob.querySelectorAll('.mn-mobile-link').forEach(function (l) { l.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mob && mob.classList.contains('is-open')) { closeMenu(); if (ham) ham.focus(); } });

  // Hero image slow zoom
  var hi = document.getElementById('mn-hero-img');
  if (hi) { hi.complete ? hi.classList.add('is-loaded') : hi.addEventListener('load', function () { hi.classList.add('is-loaded'); }); }

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); var nh = nav ? nav.offsetHeight : 0; window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - nh - 16, behavior: 'smooth' }); }
    });
  });

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mn-reveal').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.mn-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

// Email form
function handleEmailSubmit() {
  var input = document.getElementById('mn-email-input');
  var btn = input ? input.nextElementSibling : null;
  if (!input || !btn) return;
  var email = input.value.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    input.style.borderColor = 'rgba(200,80,80,.5)'; input.focus();
    setTimeout(function () { input.style.borderColor = ''; }, 1500); return;
  }
  btn.textContent = 'Done ✓'; btn.style.background = 'rgba(80,160,100,.15)'; btn.style.borderColor = 'rgba(80,160,100,.4)'; btn.style.color = 'rgba(100,200,130,.8)';
  input.value = ''; input.placeholder = "You're in."; input.disabled = true; btn.disabled = true;
}
var ei = document.getElementById('mn-email-input');
if (ei) ei.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleEmailSubmit(); });
